import { render, staticRenderFns } from "./ReviewField.vue?vue&type=template&id=17d2b5cc&scoped=true"
import script from "./ReviewField.vue?vue&type=script&lang=ts"
export * from "./ReviewField.vue?vue&type=script&lang=ts"
import style0 from "./ReviewField.vue?vue&type=style&index=0&id=17d2b5cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d2b5cc",
  null
  
)

export default component.exports